import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContentAntd"

const Sidebar = props => {
  return (
    <SidebarContent
      appMenus={props.appMenus}
      userInfo={props.userInfo}
      userBalance={props.userBalance}
      collapsed={props.type === "condensed"}
    />
  )
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStateToProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
